<template>
    <div>
        <h5 class="mb-1">
            <slot v-if="isFree" name="free"></slot>
            <span v-if="!isFree">
                {{ priceLow |money(price.currency) }}
                <template v-if="showPriceRange"> - {{ priceHigh |money(price.currency) }}</template>
            </span>
        </h5>
        <p class="mb-0">
            <slot name="description"></slot>
        </p>
        <p class="mb-0">
            <slot name="price-rise"></slot>
        </p>
    </div>
</template>

<script>

import {money} from '../../../Utility/filters/money'

export default {
    name: "Price",
    props: {
        price: {
            type: Object,
            required: true,
            default: () => {
            }
        },
    },
    filters: {
        money
    },
    computed: {
        priceLow() {
            return this.extractAndFindPrice(this.price, 'min', ['amount', 'member_amount', 'affiliation_amount']);
        },
        priceHigh() {
            return this.extractAndFindPrice(this.price, 'max', ['amount', 'member_amount', 'affiliation_amount']);
        },
        showPriceRange() {
            return this.priceHigh > this.priceLow;
        },
        isFree() {
            return this.priceLow === 0 && this.priceHigh === 0;
        }
    },
    methods: {
        extractAndFindPrice(obj, finder = 'min', properties = []) {
            // Check if the object is null or undefined
            if (obj === null || obj === undefined) {
                return null;
            }

            // Initialize an array to store valid integers
            const validIntegers = [];

            // Loop through the object properties
            for (const prop in obj) {
                if (!properties.includes(prop)) {
                    continue;
                }

                if (obj[prop] === null) {
                    continue;
                }

                validIntegers.push(Number(obj[prop]));
            }

            // If no valid integers or nulls were found, return null
            if (validIntegers.length === 0) {
                return null;
            }

            // Find and return the lowest integer
            return Math[finder](...validIntegers);
        },
    }
}
</script>

<style scoped>
p {
    font-size: 0.9em;
}

h5 {
    font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/Assets/components/RegistrationCategories/Tickets/Utility/Price.vue